/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import { ErrorIcon } from "../const/icon";
import Text from "../Text";

const StyledFormError = styled.div`
  display: flex;
  align-items: center;
`;

const FormErrorIcon = styled((props) => <ErrorIcon {...props} />)`
    stroke: rgba(${({ theme }) => theme.colors.error.rgba});
`;

const FormErrorText = styled((props) => <Text {...props} />)`
  && {
    color: rgba(${({ theme }) => theme.colors.error.rgba});
  }
`;

const FormError = ({ children, name }) => {
  return (
    <StyledFormError id={name ? `${name}-error` : undefined} role="alert">
      <FormErrorIcon width={24} height={24} />
      <FormErrorText size="small" fontStyle="italic">
        {children}
      </FormErrorText>
    </StyledFormError>
  );
};

export default FormError;
